import { h$1 as l, Y as s, u as b, m as h, o as y } from "../chunks/register-Ba9sFUKZ.js";
import * as m from "react";
import { e as i } from "../chunks/if-defined-_sZbHAlG.js";
import { o as g } from "../chunks/when-BMe_tByr.js";
import { X as p } from "../chunks/button-base-BIJ5ovE-.js";
import { v as f } from "../chunks/mixin-CP6jLr_x.js";
import { h as k, d as $ } from "../chunks/lifecycle-decorators-C04d1yHY.js";
import { e as B } from "../chunks/popover.constants-8LzWDn2s.js";
const w = l`:host([motion-state=enabled]) .icon-button{--button-base-transition-duration: var(--beacon-reference-motion-duration-5);--scale-value: 1.1;transition-property:var(--button-base-transition-property),transform}:host([motion-state=enabled]) .icon-button:is(:hover,:active){transform:scale(var(--scale-value))}:host([motion-state=enabled]) .icon-button:is(:hover,:active) .contents{transform:scale(calc(1 / var(--scale-value)))}`;
var E = (e, o, c, u) => {
  for (var r = o, n = e.length - 1, a; n >= 0; n--)
    (a = e[n]) && (r = a(r) || r);
  return r;
};
function T(e) {
  let o = class extends e {
    static get IconButtonMotionStyles() {
      return [w];
    }
  };
  return o = E([
    k("IconButtonMotion")
  ], o), o;
}
const C = l`:host{display:var(--override-icon-button-display, inline-block)}.icon-button{--active-bg: var(--beacon-system-color-background-primary-pressed);--active-border: var(--beacon-system-color-border-secondary-pressed);--active-icon: var(--beacon-system-color-icon-secondary-pressed);--bg-color: var(--beacon-system-color-background-primary);--border-color: var(--beacon-system-color-border-secondary);--border-width: var(--beacon-system-width-border-mini);--default-size: var(--beacon-reference-space-9);--disabled-bg: var(--beacon-system-color-background-primary-inactive);--disabled-border: var(--beacon-system-color-border-secondary-inactive);--disabled-icon: var(--beacon-system-color-icon-primary-inactive);--hover-bg: var(--beacon-system-color-background-primary-hover);--hover-border: var(--beacon-system-color-border-secondary-hover);--hover-icon: var(--beacon-system-color-icon-secondary-hover);--icon-color: var(--beacon-system-color-icon-primary);align-items:center;background-color:var(--override-icon-button-bg-color, var(--bg-color));block-size:var(--override-icon-button-wrapper-block-size, var(--beacon-reference-space-10));border:var(--border-width) solid var(--border-color);border-radius:var(--override-icon-button-border-radius, var(--beacon-system-radius-corner-circle));box-shadow:var(--override-icon-button-box-shadow, initial);color:var(--override-icon-button-color, var(--beacon-host-override-icon-button-color, var(--icon-color)));cursor:pointer;display:inline-flex;inline-size:var(--override-icon-button-wrapper-inline-size, var(--beacon-reference-space-10));justify-content:center;outline-offset:var(--override-icon-button-outline-offset);position:relative;padding:var(--override-icon-button-padding, 0)}.icon-button .contents{align-items:inherit;display:inherit;justify-content:inherit;position:inherit}.icon-button[aria-disabled=true]{--icon-color: var(--disabled-icon);background-color:var(--disabled-bg);border-color:var(--disabled-border);color:var(--disabled-icon);cursor:not-allowed}.icon-button svg,.icon-button [beacon-tag-name=beacon-icon]{position:absolute}.icon-button:-webkit-direct-focus{outline:-webkit-focus-ring-color auto 0}.icon-button:hover:not([aria-disabled=true]){--icon-color: var(--hover-icon);background-color:var(--hover-bg);border-color:var(--hover-border);color:var(--hover-icon)}.icon-button:active:not([aria-disabled=true]){--icon-color: var(--active-icon);background-color:var(--active-bg);border-color:var(--active-border);color:var(--active-icon)}.icon-button.primary{--active-bg: var(--override-icon-button-bg-color-pressed, var(--default-active-bg));--active-icon: var(--beacon-system-color-icon-primary);--bg-color: var(--override-icon-button-bg-color, var(--default-bg));--default-active-bg: var(--beacon-system-color-background-primary-pressed);--default-bg: var(--beacon-system-color-background-primary);--default-hover-bg: var(--beacon-system-color-background-primary-hover);--disabled-bg: var(--beacon-system-color-background-primary-inactive);--disabled-icon: var(--beacon-system-color-icon-primary-inactive);--hover-bg: var(--override-icon-button-bg-color-hover, var(--default-hover-bg));--hover-icon: var(--beacon-system-color-icon-primary);--icon-color: var(--beacon-system-color-icon-primary);border:0}.icon-button.secondary{--active-bg: var(--beacon-system-color-background-secondary-pressed);--active-border: var(--beacon-system-color-border-secondary-pressed);--active-icon: var(--beacon-system-color-icon-secondary-pressed);--bg-color: transparent;--border-color: var(--beacon-system-color-border-secondary);--disabled-bg: transparent;--disabled-border: var(--beacon-system-color-border-secondary-inactive);--disabled-icon: var(--beacon-system-color-icon-secondary-inactive);--hover-bg: var(--beacon-system-color-background-secondary-hover);--hover-border: var(--beacon-system-color-border-secondary-hover);--hover-icon: var(--beacon-system-color-icon-secondary-hover);--icon-color: var(--beacon-system-color-icon-secondary)}.icon-button.tertiary{--active-bg: var(--beacon-system-color-background-tertiary-pressed);--active-icon: var(--beacon-system-color-icon-tertiary-pressed);--bg-color: transparent;--default-hover-bg: var(--beacon-system-color-background-tertiary-hover);--default-hover-icon: var(--beacon-system-color-icon-tertiary-hover);--default-icon-color: var(--beacon-system-color-icon-tertiary);--disabled-bg: transparent;--disabled-icon: var(--beacon-system-color-icon-tertiary-inactive);--hover-bg: var(--override-icon-button-hover-bg, var(--default-hover-bg));--hover-icon: var(--override-icon-button-icon-color, var(--default-hover-icon));--icon-color: var(--override-icon-button-icon-color, var(--default-icon-color));border:0}`;
var I = Object.defineProperty, M = Object.getOwnPropertyDescriptor, A = (e, o, c, u) => {
  for (var r = M(o, c), n = e.length - 1, a; n >= 0; n--)
    (a = e[n]) && (r = a(o, c, r) || r);
  return r && I(o, c, r), r;
};
const d = "beacon-icon-button", v = class extends f(p).with(
  T
) {
  constructor() {
    super(...arguments), this.beaconTagName = d;
  }
  static get styles() {
    return [super.styles, C, this.IconButtonMotionStyles];
  }
  /**
   * Returns the closest beacon-popover parent to determine if the related data-metrics-location attribute should apply
   */
  get isPopoverChild() {
    return !!this.closest('[beacon-tag-name="beacon-popover"]');
  }
  applyDataMetricsLocation() {
    this.isPopoverChild && this.setAttribute(
      "data-metrics-location",
      B.DATA_METRICS_LOCATION_BODY
    );
  }
  /**
   * Render function for beacon-button if link-href propety is passed in to support links as buttons
   *
   * @returns {TemplateResult} returns an `<a>` tag styled as a button
   */
  renderAnchorTag() {
    var o;
    return s` <a
      part="icon-link"
      id="${i(this._passthroughs.attributes.get("id"))}"
      @click=${this.handleClick}
      href="${this.linkHref}"
      download="${i(this.linkDownload)}"
      target="${i(this.linkTarget)}"
      class="icon-button ${this.variant}"
      aria-disabled="${this.disabled}"
      aria-label="${(o = this.defaultSlotText) != null ? o : b}">
      <span class="contents">
        <slot name="icon" @slotchange=${this.handleIconSlotchange}></slot>
      </span>
    </a>`;
  }
  /**
   * Render function for beacon-button as a `<button>` element
   *
   * @returns {TemplateResult} returns a `<button>` tag as the template
   */
  renderButtonTag() {
    var o;
    return s`
      <button
        part="icon-button"
        id="${i(this._passthroughs.attributes.get("id"))}"
        @click=${this.handleClick}
        class="icon-button ${this.variant}"
        aria-disabled="${this.disabled}"
        aria-label="${(o = this.defaultSlotText) != null ? o : b}">
        <span class="contents">
          <slot name="icon" @slotchange=${this.handleIconSlotchange}></slot>
        </span>
      </button>
    `;
  }
  render() {
    return s`<slot
        style="display: none"
        @slotchange=${() => {
      this.requestUpdate();
    }}></slot>
      ${g(
      this.linkHref,
      () => this.renderAnchorTag(),
      () => this.renderButtonTag()
    )}`;
  }
};
v.tagName = d;
let t = v;
A([
  $
], t.prototype, "applyDataMetricsLocation");
const P = (e) => (h(e, t), y({
  tagName: e ? e + "-" + t.tagName : t.tagName,
  elementClass: t,
  react: m,
  events: {
    onBeaconEventClick: "beacon-event-click",
    onBeaconEventRenderActionZone: "beacon-event-render-action-zone",
    onBeaconEventInput: "beacon-event-input",
    onBeaconEventChange: "beacon-event-change",
    onBeaconEventFocus: "beacon-event-focus",
    onBeaconEventBlur: "beacon-event-blur",
    onBeaconEventMousedown: "beacon-event-mousedown",
    onBeaconEventKeydown: "beacon-event-keydown",
    onBeaconEventRender: "beacon-event-render",
    onBeaconEventDeferredChild: "beacon-event-deferred-child",
    onBeaconEventMouseenter: "beacon-event-mouseenter",
    onBeaconEventMouseleave: "beacon-event-mouseleave",
    onBeaconEventHide: "beacon-event-hide"
  }
}));
export {
  P as default,
  P as reactBeaconIconButton
};
